import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MousePressDirective } from '@app/shared/directives/mouse-press.directive';
import { TcFinalPromiseDirective } from '@app/shared/directives/tc-final-promise.directive';
import { Subscription } from 'rxjs';
import { EBtnHierarchyType } from './types/hierarchy.type';
import { EBtnSizeType } from './types/size.type';
import { EBtnAttributeMatType } from './types/attribute-mat.type';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'tc-new-button',
    imports: [
        MatButtonModule,
        MousePressDirective,
        TcFinalPromiseDirective,
        NgClass,
        RouterLink
    ],
    templateUrl: './new-button.component.html',
    styleUrl: './new-button.component.scss'
})
export class NewButtonComponent implements OnChanges {

  // Output
  @Output() clickBtn = new EventEmitter<void>();

  // Input
  @Input() btnType: 'submit' | 'button' = 'submit';
  @Input() submitSubscription: Subscription;
  @Input({ required: true }) attributeVariantsType: EBtnAttributeMatType;
  @Input({ required: true }) hierarchyType: EBtnHierarchyType;
  @Input({ required: true }) sizeType: EBtnSizeType;
  @Input() routerLink: string | any[] | null = null;
  @Input() isJustIcon: boolean = false;
  @Input() hasOneIcon: boolean = false;
  @Input() isRound: boolean = false;
  @Input() isDestructive: boolean = false;
  @Input() isWarning: boolean = false;
  @Input() isLoading = false;
  @Input() isDisabled = false;

  // string
  hierarchyClass: string;
  sizeClass: string;


  // type
  attributeType = EBtnAttributeMatType;

  //==================================
  // #region LIFE CYCLE HOOK 
  //==================================
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['hierarchyType']) {
      this.handleHierarchyClass(changes);
    }
    if (changes['sizeType']) {
      this.handleSizeClass(changes);
    }
  }



  //#endregion
  //==================================
  // #region PUBLIC 
  //==================================
  submit(): void {
    if (!this.isDisabled && !this.isLoading) {
      this.clickBtn.emit();
    }
  }
  //#endregion
  //==================================
  // #region PRIVATE 
  //==================================
  private handleHierarchyClass(changes: SimpleChanges): void {
    let hierarchy = changes['hierarchyType'].currentValue;
    switch (hierarchy) {
      case EBtnHierarchyType.Primary: {
        this.hierarchyClass = 'btn-primary-new';
        break;
      }
      case EBtnHierarchyType.Secondary: {
        this.hierarchyClass = 'btn-secondary-new';
        break;
      }
      case EBtnHierarchyType.Tertiary: {
        this.hierarchyClass = 'btn-tertiary-new';
        break;
      }
      case EBtnHierarchyType.LinkColor: {
        this.hierarchyClass = 'btn-link-new';
        break;
      }
      case EBtnHierarchyType.Close: {
        this.hierarchyClass = 'btn-close-icon';
        break;
      }
    }
  }

  private handleSizeClass(changes: SimpleChanges): void {
    let size = changes['sizeType'].currentValue;
    switch (size) {
      case EBtnSizeType.XS: {
        this.sizeClass = 'size-xs';
        break;
      }
      case EBtnSizeType.SM: {
        this.sizeClass = 'size-sm';
        break;
      }
      case EBtnSizeType.MD: {
        this.sizeClass = 'size-md';
        break;
      }
      case EBtnSizeType.LG: {
        this.sizeClass = 'size-lg';
        break;
      }
      case EBtnSizeType.XL: {
        this.sizeClass = 'size-xl';
        break;
      }
      case EBtnSizeType.XXL: {
        this.sizeClass = 'size-2xl';
        break;
      }
    }
  }
  //#endregion
}
